module.exports = __webpack_public_path__ + "img/miner_bg.27a362a5.gif";